/* eslint-disable no-useless-escape */
export const isExternalLink = (link: string) => link.includes('http')

export const formatDataFamilySlug = (name: string): string => {
  return name.replace('+', '-plus')
}
